import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  padding: ${grid.lg} ${grid.lg} 8.57rem ${grid.lg};
`;
